/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tier_Feature_Intelligence_FullInputs */

const en_tier_feature_intelligence_full = /** @type {(inputs: Tier_Feature_Intelligence_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full AI Concierge & RAG`)
};

const es_tier_feature_intelligence_full = /** @type {(inputs: Tier_Feature_Intelligence_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conserje IA completo y RAG`)
};

const fr_tier_feature_intelligence_full = /** @type {(inputs: Tier_Feature_Intelligence_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concierge IA complet & RAG`)
};

const de_tier_feature_intelligence_full = /** @type {(inputs: Tier_Feature_Intelligence_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständiger KI-Concierge & RAG`)
};

const ja_tier_feature_intelligence_full = /** @type {(inputs: Tier_Feature_Intelligence_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全なAIコンシェルジュ ＆ RAG`)
};

const zh_tier_feature_intelligence_full = /** @type {(inputs: Tier_Feature_Intelligence_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整的 AI 礼宾客服 & RAG`)
};

const ar_tier_feature_intelligence_full = /** @type {(inputs: Tier_Feature_Intelligence_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مساعد ذكي كامل وتقنية RAG`)
};

const id_tier_feature_intelligence_full = /** @type {(inputs: Tier_Feature_Intelligence_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pramutamu AI Penuh & RAG`)
};

const it_tier_feature_intelligence_full = /** @type {(inputs: Tier_Feature_Intelligence_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concierge IA Completo & RAG`)
};

const ru_tier_feature_intelligence_full = /** @type {(inputs: Tier_Feature_Intelligence_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полный ИИ-Консьерж и RAG`)
};

const pt_tier_feature_intelligence_full = /** @type {(inputs: Tier_Feature_Intelligence_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concierge IA Completo e RAG`)
};

const ko_tier_feature_intelligence_full = /** @type {(inputs: Tier_Feature_Intelligence_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`풀 AI 컨시어지 및 RAG`)
};

/**
* | output |
* | --- |
* | "Full AI Concierge & RAG" |
*
* @param {Tier_Feature_Intelligence_FullInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tier_feature_intelligence_full = /** @type {((inputs?: Tier_Feature_Intelligence_FullInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tier_Feature_Intelligence_FullInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tier_feature_intelligence_full(inputs)
	if (locale === "es") return es_tier_feature_intelligence_full(inputs)
	if (locale === "fr") return fr_tier_feature_intelligence_full(inputs)
	if (locale === "de") return de_tier_feature_intelligence_full(inputs)
	if (locale === "ja") return ja_tier_feature_intelligence_full(inputs)
	if (locale === "zh") return zh_tier_feature_intelligence_full(inputs)
	if (locale === "ar") return ar_tier_feature_intelligence_full(inputs)
	if (locale === "id") return id_tier_feature_intelligence_full(inputs)
	if (locale === "it") return it_tier_feature_intelligence_full(inputs)
	if (locale === "ru") return ru_tier_feature_intelligence_full(inputs)
	if (locale === "pt") return pt_tier_feature_intelligence_full(inputs)
	return ko_tier_feature_intelligence_full(inputs)
});